import { createSelector } from 'reselect';
import { channelsSelector } from 'common/selectors';

/**
 * @param {*} state
 * @param {*} match
 * @return null|{number} channelID
 */
export const urlChannelIdSelector = (params) => (state) => {
  const channelId = params.channelId ? +params.channelId : null;
  const channels = channelsSelector(state);

  if (!channelId) {
    return null;
  }

  // Validate if channelId from url is valid CT channel
  if (channels.length > 0) {
    if (channels.find((channel) => channel.id === channelId)) {
      return channelId;
    } else {
      return null;
    }
  }
  return channelId;
};

/**
 * @param {*} state
 * @param {*} params - match.params
 * @return {string} slug
 */
export const urlChannelSlugSelector = createSelector(
  (state, params) => params.channelSlug || 'slug',
  (slug) => slug
);

/**
 * @param {*} state
 * @param {*} match
 * @return null|{string} videoId
 */
export const urlVideoIdSelector = createSelector(
  (state, match) => (match && match.params.videoId ? match.params.videoId : null),
  (urlVideoId) => urlVideoId
);

/**
 * @param {*} state
 * @param {*} match
 * @return null|{string} sort
 */
export const urlSavedVideosSortingSelector = createSelector(
  (state, match) => (match && match.params.sort ? match.params.sort : 'recently_added'),
  (sort) => sort
);
